/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-lone-blocks */
import { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import ReactQuill from 'react-quill-new'
import 'react-quill-new/dist/quill.snow.css'
import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import {NavbarTopAdmin, NavbarBottomAdmin} from '../admin/components'
import AddImg from '../admin/components/addImg'
import { useDispatch, useSelector } from 'react-redux'
import { aggiorna } from '../../redux/creaEvento'
import { useNavigate } from 'react-router-dom'
import DivBottom from '../userNotAuth/components/divBottom'
import { RotatingLines } from "react-loader-spinner"

let opzioniEventoArr = []

function AddEvento2() {
    const redux = useSelector((state) => state.creaEvento.value)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [formData2, setFormData2] = useState({
        addobbi: redux.addobbi,
        artisti: redux.artisti,
        areaTavoli: redux.areaTavoli,
        attrazioniBambini: redux.attrazioniBambini,
        biglietto: redux.biglietto,
        birraArtigianale: redux.birraArtigianale,
        centroStorico: redux.centroStorico,
        descrizione: redux.descrizione,
        djSet: redux.djSet,
        email: redux.email,
        fb: redux.fb,
        fiera: redux.fiera,
        foto: redux.foto,
        gruppo: redux.gruppo,
        incorporaUrl: redux.incorporaUrl,
        infoOrganizzatore: redux.infoOrganizzatore,
        liscio: redux.liscio,
        mercatini: redux.mercatini,
        musica: redux.musica,
        navetta: redux.navetta,
        noBiglietto: redux.noBiglietto,
        opzioniEvento: redux.opzioniEvento,
        ospite1: redux.ospite1,
        ospite2: redux.ospite2,
        ospite3: redux.ospite3,
        ospite4: redux.ospite4,
        ospite5: redux.ospite5,
        opzioniBiglietto: redux.opzioniBiglietto,
        parcheggio: redux.parcheggio,
        prezzo: redux.prezzo,
        scuolaDiBallo: redux.scuolaDiBallo,
        standGastronomici: redux.standGastronomici,
        sito: redux.sito,
        telefono: redux.telefono,
        youTube: redux.youTube,
        url: redux.url,
        video: redux.video
    })
    const [foto, setFoto] = useState([])
    const [validate, setValidate] = useState({ prezzo: null, videoStateMessage: null })
    const [textEmpty, setTextEmpty] = useState({
        descrizione: null, sitoWeb: null, emailValidate: null, opzioniBiglietto: null, telefono: null, infoOrganizzatore: null
    })

    const numFoto = [0, 1, 2] // NUMERO MASSIMO DI FOTO (è l'index nel loop in html) ----------
    const ospiti = [1, 2, 3, 4, 5]// NUMERO MASSIMO DI OSPITI

    const prezzoDom = useRef(); const prezzoId = useRef(); const descrizione = useRef()
    const bannerSitoUff = useRef(); const btnInfoSitoUff = useRef()
    const sitoFacol_Obbl = useRef('opzionale')

    const videoChange = async (e) => {
        if (e.target.files[0]) {
            const ETarget = e.target.files[0]
            if (ETarget.type.startsWith('video/')) {
                if (ETarget.size > 100000000) {
                    setValidate({ ...validate, videoStateMessage: '*** Video troppo grande...max 100 mega ***' })
                    return
                }
                const v = document.getElementById('progress')
                v.style.width = '94%'; v.style.transition = 'width 40s'; document.getElementById('container').style.border = '1px solid black'
                setValidate({ ...validate, videoStateMessage: 'Attendere...upload video in corso' })
                document.getElementById('rotaryVideo').style.display = 'block'

                // ----------------- controllo durata del video in secondi ----------------
                const videoForDurata = document.createElement('video')
                videoForDurata.src = URL.createObjectURL(ETarget)
                videoForDurata.onloadedmetadata = async function () {
                    const duration = videoForDurata.duration
                    if (duration > 300) {
                        setValidate({ ...validate, videoStateMessage: '*** Video troppo lungo (max 5 min) ***' })
                        window.URL.revokeObjectURL(videoForDurata.src)
                        document.getElementById('rotaryVideo').style.display = 'none'

                    } else {// ------ ACCETTAZIONE VIDEO ----------------------------------------   
                        // rinomino il video con un nome random
                        let extens = ETarget.name.substring(ETarget.name.lastIndexOf('.') + 1)// ricavo l'estensione
                        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'// prendi questi caratteri per generare la stringa random
                        let result = ''
                        const charactersLength = characters.length
                        for (let i = 0; i < 15; i++) {
                            result += characters.charAt(Math.floor(Math.random() * charactersLength))
                        }
                        const zxc = `ZE_${result}.${extens}` // aggiungo ZE alla stringa random (+ l'estensione) che darà il nome al video
                        document.getElementById('upload-video').disabled = true

                        function uploadThenSuccess(videoName) {
                            setValidate({ ...validate, videoStateMessage: 'Video caricato con successo' })
                            setFormData2({ ...formData2, video: videoName }) //formData2.video è il nome del video che andrà in MYSQL
                            v.style.transition = 'width 0.1s'; v.style.width = '100%'; document.getElementById('container').style.border = '1px solid black'
                            document.getElementById('lblVideo').style.display = 'none' // +video
                            document.getElementById('rotaryVideo').style.display = 'none'
                            document.getElementById('upload-video').disabled = false
                        }
                        function uploadThenFailed() {
                            document.getElementById('rotaryVideo').style.display = 'none'
                            setValidate({ ...validate, videoStateMessage: '*** Problemi con il server...riprova ***' })
                            v.style.width = '0'; v.style.transition = 'width 0.1s'; document.getElementById('container').style.border = '1px solid transparent'
                            document.getElementById('upload-video').disabled = false
                            document.getElementById('upload-video').value = ''
                        }
                        const fd = new FormData(); let flagCompress

                        if (ETarget.size > 25000000) {//video > 25 mega non lo mando al server Heroku perchè lo saturerebbe in sovraccarico
                            flagCompress = 'compress_off'
                        } else {//video < 25 mega può essere compresso dal server
                            flagCompress = 'compress_on'
                        }
                        fd.append('video', ETarget); fd.append('nomeVideo', zxc); fd.append('stato', 'siAwsBucket')
                        try {
                            const res = await axios.post(`/convertVideo/${flagCompress}`, fd, {
                                headers: { "Content-Type": "multipart/form-data" }
                            })
                            if (res.data === 'success') {
                                if (flagCompress === 'compress_on') uploadThenSuccess(`ZE_${result}.mp4`)
                                if (flagCompress === 'compress_off') uploadThenSuccess(zxc)
                            } else uploadThenFailed()
                        } catch (err) { console.log("Errore durante l'upload", err) }
                    }
                }
            }
            else {
                //video type non conforme
                setValidate({ ...validate, videoStateMessage: '*** Tipo video non conforme ***' })
                e.target.value = ""; return
            }
        }
    }
    const videoRemove = async (e) => {
        const v = document.getElementById('progress')
        v.style.width = '0'; v.style.transition = 'width 0.1s'; document.getElementById('container').style.border = '1px solid transparent'
        document.getElementById('upload-video').value = ''
        function removeFadeOut(elment, speed) {
            let seconds = speed / 300
            elment.style.transition = "opacity " + seconds + "s ease"
            elment.style.opacity = 0
            setTimeout(() => {
                setFormData2({ ...formData2, video: null })
                setTimeout(() => {
                    elment.style.opacity = 1; document.getElementById('lblVideo').style.display = 'block'//visualizzo '+video'  
                }, 50)
            }, speed)
        }
        // const fd = new FormData()
        // fd.append('videoDelete', formData2.video)
        try {
            axios.delete(`/delete-video/${formData2.video}`)
            // const res2 = await axios.post(`/removeVideo/eventi`, fd)//rimuovo video da cloudinary
        } catch (err) { setValidate({ ...validate, videoStateMessage: '*** Problemi con la connessione...riprova ***' }); console.error(err); return }
        removeFadeOut(document.getElementById('videoPreview'), 200)
        removeFadeOut(document.getElementById('iconaDelVideo'), 200)
        setValidate({ ...validate, videoStateMessage: null })
    }
    function handleInputChange(e) {
        setTextEmpty({ sitoWeb: null })
        setValidate({ prezzo: null })
        const { name, value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value
        setFormData2({ ...formData2, [name]: inputValue })//valorizzo il name del nuovo oggetto formData 
        switch (name) {
            case 'biglietto': {
                setFormData2({ ...formData2, biglietto: true, noBiglietto: false, sito: false })
                sitoFacol_Obbl.current = 'opzionale'
            }
                break
            case 'noBiglietto': {
                setFormData2({ ...formData2, biglietto: false, noBiglietto: true, sito: false })
                sitoFacol_Obbl.current = 'opzionale'
            }
                break
            case 'sito': {
                setFormData2({ ...formData2, biglietto: false, noBiglietto: false, sito: true })
                sitoFacol_Obbl.current = 'obbligatorio'
            }
                break
            default: console.log(name)
        }
        if (name === 'telefono') {
            if (/^[0-9\s-]+$/.test(inputValue) === false && inputValue) { setTextEmpty({ ...textEmpty, telefono: '*** Campo numerico ***' }) }; return
        }
        prezzoId.current.style.border !== '1px solid black' && (prezzoId.current.style.border = '1px solid black')
    }
    function handleDescrizione(e) {
        setFormData2({ ...formData2, descrizione: e })
        setTextEmpty({ descrizione: formData2.descrizione.length })
    }
    function handleOpzioniEvento(e) {
        const { name, value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value
        if (inputValue === true) {
            opzioniEventoArr.push(name)
        } else
            if (inputValue === false) {
                opzioniEventoArr = opzioniEventoArr.filter(item => item !== name)
            }
        setFormData2({ ...formData2, [name]: inputValue, opzioniEvento: opzioniEventoArr })
    }
    async function handleSubmit(e) {
        e.preventDefault()//al onSubmit la pagina non si aggiorna perchè abbiamo prevenuto il default
        if (formData2.descrizione.length > 5500 || formData2.descrizione.length === 0) {
            setTextEmpty({ descrizione: 'max 5500' }); window.scrollTo(0, 150)
            descrizione.current.style.border = '1px solid red'; return
        }
        if (formData2.sito === true && formData2.url === "") {
            setTextEmpty({ sitoWeb: 'Campo obbligatorio' }); window.scrollTo(0, 1300); return
        }
        const validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!validRegex.test(formData2.email) || formData2.email === '') {
            setTextEmpty({ emailValidate: 'Email non valida' }); return
        }
        if (formData2.telefono && /^[0-9\s-]+$/.test(formData2.telefono) === false) {
            setTextEmpty({ telefono: '*** Campo numerico ***' }); window.scrollTo(0, 1800); return
        }
        if (formData2.biglietto === true) {
            if (formData2.prezzo === '') {
                setValidate({ prezzo: 'Campo obbligatorio' })
                prezzoId.current.style.border = '1px solid red'; return
            } else
                if (formData2.prezzo <= 0) {
                    setValidate({ prezzo: 'Valore errato' })
                    prezzoId.current.style.border = '1px solid red'; return
                }
        } else formData2.prezzo = 0
        //ACCETTAZIONE EVENTO
        const object = { ...formData2, foto: foto }
        dispatch(aggiorna(object))
        setTimeout(() => {
            navigate('/confirmAddEvento', { replace: true })
        }, 200)
    }
    function vaiAlSitoUff() {
        bannerSitoUff.current.style.display = 'block'
        btnInfoSitoUff.current.style.display = 'none'
        let time = setTimeout(editBanner, 8000)
        document.addEventListener('mouseup', () => {
            bannerSitoUff.current.style.display = 'none'
            btnInfoSitoUff.current.style.display = 'block'
            clearTimeout(time)
        })
        function editBanner() {
            bannerSitoUff.current.style.display = 'none'
            btnInfoSitoUff.current.style.display = 'block'
        }
    }
    function controlNavbar() {
        if (window.scrollY < 30) { window.scrollTo(0, 31) }
    }

    useEffect(() => {
        window.scrollTo(0, 0)

        // --------------- settaggio foto e video a caricamento pagina 
        if (redux.foto.length !== 0) {
            setFoto(redux.foto)
            for (let w = 0; w < redux.foto.length; w++) {//settaggio label (+foto)
                document.getElementById('label' + w).style.display = 'none'
            }
            if (redux.foto.length < numFoto.length - 1) {//settaggio input foto = disabled
                let index = redux.foto.length
                for (let h = 1; h <= numFoto.length; h++) {//loop di tutti i div contenenti gli input type file
                    if (h > (index + 1)) {
                        document.getElementById('upload-photo' + (h - 1)).disabled = true
                    }
                }
            }
        } else {
            for (let h = 1; h < numFoto.length; h++) {//loop di tutti i div contenenti gli input type file
                document.getElementById('upload-photo' + (h)).disabled = true// disabilito tutti gli input foto tranne il primo
            }
        }
        if (redux.video) {
            document.getElementById('lblVideo').style.display = 'none' // +video
        }

        // ------------------- settaggio div aggiungi ospiti
        if (formData2.ospite1 + formData2.ospite2 + formData2.ospite3 + formData2.ospite4 + formData2.ospite5) {
            document.getElementById('divAggiungiOspiti').style.display = 'block'
        }

        opzioniEventoArr = redux.opzioniEvento.filter(item => item !== '')
        document.body.style.overscrollBehaviorY = 'contain'//disattiva il "pull-to-refresh"
        window.addEventListener('scroll', controlNavbar)
        return () => { window.removeEventListener('scroll', controlNavbar) }
    }, [])

    useEffect(() => {//gestione del DOM prezzo del biglietto e sue opzioni
        if (formData2.biglietto === true) {
            prezzoDom.current.style.display = 'block'
            setFormData2({ ...formData2, noBiglietto: false })
        } else {
            prezzoDom.current.style.display = 'none'
            prezzoId.current.value = ''
            setFormData2({ ...formData2, prezzo: '', opzioniBiglietto: '' })
        }
    }, [formData2.biglietto])

    // useEffect(() => { console.log('formData2:', formData2.descrizione) }, [formData2.descrizione])

    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />
        }
        <div className='container'>
            <h2 style={{ marginTop: '7rem' }}>AGGIUNGI UN EVENTO (2)</h2>

            {/* ----------------- Descrizione --------------------- */}
            <h4 style={{ marginTop: '3rem' }}>DESCRIVI L'EVENTO *<span style={{ color: 'maroon', fontSize: 'small' }}> (max 5500)</span></h4>
            <p><i>Ad esempio qualche particolare importante dell'evento o la presenza di stand gastronomici...</i></p>
            <div ref={descrizione}>
                <ReactQuill className="textarea-quill"
                    value={formData2.descrizione}
                    theme="snow"
                    onChange={handleDescrizione}
                    placeholder="Es: dal 1 al 4 novembre si svolgerà a Spoleto il grande Show dell' open jazz band..."
                    modules={{
                        toolbar: [
                            ['bold', 'italic', 'underline'], // Solo le funzioni base che ti servono
                            ['link'],
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                            ['clean'] // Rimuove la formattazione se l'utente incolla testo sporco
                        ]
                    }}
                />
            </div>
            {textEmpty.descrizione && <p style={{ color: 'red', fontSize: 'small' }}><i>{textEmpty.descrizione} - max 5500</i></p>}

            {/* ------------------- Aggiungi OSPITI ------------------------------ */}
            <div>
                <h5 style={{ marginTop: '3rem' }}>AGGIUNGI OSPITI
                    <span style={{ border: '1px solid grey', marginLeft: '5px', padding: '0 10px', cursor: 'pointer', fontSize: 'medium' }} id="spanOspiti" onClick={() => {
                        const xcv = document.getElementById('divAggiungiOspiti')
                        const bnm = document.getElementById('spanOspiti')
                        if (bnm.textContent === '+') { bnm.innerHTML = '-'; xcv.style.display = 'block' }
                        else { bnm.innerHTML = '+'; xcv.style.display = 'none' }
                    }}>+</span>
                </h5>
                <div id="divAggiungiOspiti" style={{ display: 'none' }}>
                    <i style={{ fontSize: 'small', color: 'maroon' }}>Usa % per separare l'ospite da eventuali dettagli (es. Bach Orchestra%Trio di musica classica)</i>
                    {ospiti.map((ospite) => {
                        const nm = "ospite" + ospite
                        return (
                            <input key={ospite} className="form-control mt-3"
                                name={`ospite${ospite}`}
                                maxLength={300}
                                onChange={handleInputChange}
                                placeholder={`ospite ${ospite}`}
                                type="text"
                                defaultValue={formData2[nm]}// chiave dinamica
                            />
                        )
                    })
                    }
                </div><hr />
            </div>

            <form onSubmit={handleSubmit}>
                {/* ---------------------- Aggiungi immagini ----------------------- */}
                <AddImg numero={[0, 1, 2]} folder={''} invioFoto={(e) => { setFoto(e) }}/>

                {/* ----------------------- Aggiungi video ------------------- */}
                <div>
                    <h4 style={{ marginTop: '0rem' }}>AGGIUNGI VIDEO (max 5 min)</h4>
                    <p style={{ opacity: '.7' }}><i>*** opzionale ***</i></p>
                    <div style={{ border: '2px solid cornflowerblue', width: '200px', height: '130px', textAlign: 'center', margin: '2em 0 0 3em', borderRadius: '5px' }}>
                        <label htmlFor="upload-video" style={{ cursor: 'pointer' }} id='lblVideo'>
                            + Video
                            <span id="rotaryVideo" style={{ display: 'none' }}>
                                <RotatingLines strokeColor='black' strokeWidth='5' animationDuration='5' width='26' />
                            </span>
                        </label>
                        {formData2.video &&
                            <div>
                                <div style={{ marginTop: '-28px' }}>
                                    <button style={{ marginLeft: '9.5rem', border: 'transparent', backgroundColor: 'transparent' }}
                                        onClick={videoRemove} id={'iconaDelVideo'} type='button'>
                                        ❌
                                    </button>
                                </div>

                                {/* ------------- preview del video proveniente da MYSQL saved in AWS ------------ */}
                                <video src={`https://leuro-bucket.s3.amazonaws.com/video/${formData2.video}`} id={'videoPreview'}
                                    style={{ width: '198px', height: '128px', borderRadius: '5px' }} controls />
                                {/* <AdvancedVideo cldVid={myCld.video(formData2.video)} id={'videoPreview'}
                                    style={{ width: '144px', height: '80px', borderRadius: '5px' }} controls /> */}
                            </div>
                        }
                        <input id='upload-video' style={{ opacity: '0', fontSize: '0px' }}
                            type='file'
                            name='video'
                            accept="video/*"
                            onChange={videoChange} />
                    </div>

                    {/* ------------ barra di avanzamento ----------------------- */}
                    <div style={{ width: '35%', backgroundColor: 'transparent', margin: '1em 0 0 1em' }} id='container'>
                        <div style={{ width: '0', height: '10px', backgroundColor: 'darkturquoise' }} id='progress'>
                        </div>
                    </div>
                    {validate.videoStateMessage &&
                        <p style={{ color: 'navy', margin: '0 0 0 1em' }}><i>{validate.videoStateMessage}</i></p>
                    }
                </div><br />

                {/* --------------------------- Incorpora Video ------------------ */}
                <div>
                    <p className='fs-4'>INCORPORA UN VIDEO DA YOUTUBE
                        <span style={{ fontSize: 'x-small', backgroundColor: 'maroon', color: 'white', borderRadius: '5px', marginLeft: '1em', padding: '5px', cursor: 'pointer' }}
                            onClick={() => {
                                document.getElementById('esempioIncorp').style.display = 'block'; setTimeout(() => {
                                    document.getElementById('esempioIncorp').style.display = 'none'
                                }, 15000)
                            }}
                        >esempio
                        </span>
                    </p>
                    <input className="form-control"
                        defaultValue={formData2.incorporaUrl}
                        name='incorporaUrl'
                        onChange={handleInputChange}
                        placeholder='URL del video'
                        type='text' />
                    <div id='esempioIncorp' style={{
                        border: '1px solid grey', width: '40%', height: '220px', position: 'absolute', backgroundColor: 'whitesmoke', left: '14em',
                        fontSize: 'small', padding: '10px', display: 'none'
                    }}>
                        <img src={require('../userNotAuth/image/icons8-chiudi-macos-32.png')} style={{ cursor: 'pointer' }} alt=''
                            onClick={() => { document.getElementById('esempioIncorp').style.display = 'none' }} />
                        Sopra al video di YouTube clicca con il tasto destro del mouse e seleziona <i>Copia URL Video</i>. Poi incolla l'URL appena copiato nel campo <i>URL del video</i> qui sopra.
                    </div>
                </div>

                {/* ------------------ Opzioni Evento --------------- */}
                <h5 style={{ marginTop: '1rem' }}>OPZIONI EVENTO</h5>
                <div className='mt-3' style={{ display: 'grid', gridTemplateColumns: '2rem 14rem', gap: '4px' }} >
                    <div><input type='checkbox'
                        name='parcheggio'
                        checked={formData2.parcheggio}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Parcheggio gratuito</label></div>

                    <div><input type='checkbox'
                        name='navetta'
                        checked={formData2.navetta}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Servizio navetta</label></div>

                    <div><input type='checkbox'
                        name='mercatini'
                        checked={formData2.mercatini}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Mercatini</label></div>

                    <div><input type='checkbox'
                        name='fiera'
                        checked={formData2.fiera}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Fiera Espositiva</label></div>

                    <div><input type='checkbox'
                        name='standGastronomici'
                        checked={formData2.standGastronomici}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Stand gastronomici</label></div>

                    <div><input type='checkbox'
                        name='streetFood'
                        checked={formData2.streetFood}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Street Food</label></div>

                    <div><input type='checkbox'
                        name='areaTavoli'
                        checked={formData2.areaTavoli}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Area tavoli</label></div>

                    <div><input type='checkbox'
                        name='birraArtigianale'
                        checked={formData2.birraArtigianale}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Birra artigianale</label></div>

                    <div><input type='checkbox'
                        name='musica'
                        checked={formData2.musica}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Musica dal vivo</label></div>

                    <div><input type='checkbox'
                        name='djSet'
                        checked={formData2.djSet}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Dj-set</label></div>

                    <div><input type='checkbox'
                        name='addobbi'
                        checked={formData2.addobbi}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Addobbi scenografici</label></div>

                    <div><input type='checkbox'
                        name='artisti'
                        checked={formData2.artisti}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Artisti di strada</label></div>

                    <div><input type='checkbox'
                        name='truccabimbi'
                        checked={formData2.truccabimbi}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Truccabimbi</label></div>

                    <div><input type='checkbox'
                        name='centroStorico'
                        checked={formData2.centroStorico}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Centro storico visitabile</label></div>

                    <div><input type='checkbox'
                        name='attrazioniBambini'
                        checked={formData2.attrazioniBambini}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Attrazioni per bambini</label></div>

                    <div><input type='checkbox'
                        name='liscio'
                        checked={formData2.liscio}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Ballo liscio</label></div>

                    <div><input type='checkbox'
                        name='gruppo'
                        checked={formData2.gruppo}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Balli di gruppo</label></div>

                    <div><input type='checkbox'
                        name='scuolaDiBallo'
                        checked={formData2.scuolaDiBallo}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Scuola di ballo</label></div>
                </div><hr />

                <div className="col-md-6 mt-2"> {/* ------------------ LINK --------------- */}
                    <h5 style={{ fontFamily: 'sans-serif', marginTop: '3rem' }}>LINK</h5>
                    {/* ---------------------- Sito web -------------------- */}
                    <div style={{ marginLeft: '1rem' }}>
                        <label htmlFor='email' className='mt-1'>URL sito web
                            <img className='ms-1' src={require('../userNotAuth/image/icons8-sito-web-30.png')} alt='' width={20} />
                        </label>
                        <input className="form-control"
                            name="url"
                            maxLength={250}
                            onChange={handleInputChange}
                            placeholder='es: https://www.zona-eventi.it/'
                            type="text" />
                        {textEmpty.sitoWeb && <p style={{ color: 'red', fontSize: 'small' }}><i>{textEmpty.sitoWeb}</i></p>}

                        <label htmlFor='email' className='mt-3'>URL Facebook
                            <img className='ms-1' src={require('../userNotAuth/image/icons8-fb-48.png')} alt='' width={20} />
                        </label>
                        <input className="form-control"
                            name="fb"
                            maxLength={250}
                            onChange={handleInputChange}
                            placeholder='es: https://www.facebook.com/'
                            type="text" />

                        <label htmlFor='email' className='mt-3'>URL INSTAGRAM
                            <img className='ms-1' src={require('../userNotAuth/image/icons8-instagram-48.png')} alt='' width={20} />
                        </label>
                        <input className="form-control"
                            name="youTube"
                            maxLength={250}
                            onChange={handleInputChange}
                            placeholder='es: https://www.instagram.com/'
                            type="text" />
                    </div>

                    {/* ----------------------- Telefono ----------------- */}
                    <h5 style={{ marginTop: '2rem' }}>INFO ORGANIZZATORE</h5>
                    <div className='mt-2'> <label htmlFor='form-control fw-bold'>Telefono</label></div>
                    <input className="form-control" id="telefono"
                        defaultValue={formData2.telefono}
                        name='telefono'
                        maxLength={20}
                        onChange={handleInputChange}
                        placeholder='opzionale'
                        type='text' />
                    {textEmpty.telefono && <p style={{ color: 'red' }}>{textEmpty.telefono}</p>}

                    {/* -------------------------- Email -------------------- */}
                    <label htmlFor='form-control fw-bold'>Email *</label>
                    <input className="form-control" id="email"
                        defaultValue={formData2.email}
                        name='email'
                        required
                        onChange={handleInputChange}
                        placeholder='es. zonaeventiinfo@gmail.com'
                        type='text' />
                    {textEmpty.emailValidate && <p style={{ color: 'red' }}>{textEmpty.emailValidate}</p>}
                </div>

                {/* ----------------- Descrizione Organizzazione --------------------- */}
                <p className='mt-3'>Descrizione organizzatore <span style={{ color: 'maroon', fontSize: 'small' }}> (max 1000)</span></p>
                <textarea style={{ padding: '5px', marginTop: '10px' }} className='form-control' id="infoOrganizzatore"
                    name="infoOrganizzatore"
                    rows='10'
                    maxLength={1000}
                    onChange={handleInputChange}
                    placeholder="Es: l'associazione nasce 1 anno fa per opera di..."
                    defaultValue={formData2.infoOrganizzatore}
                >
                </textarea>
                {textEmpty.infoOrganizzatore && <p style={{ color: 'red' }}>{textEmpty.infoOrganizzatore}</p>}

                {/* ------------------ Biglietto ----------------- */}
                <div>
                    <h5 className='mt-2'>OPZIONI BIGLIETTO</h5>
                    <div style={{
                        display: 'grid', gridTemplateColumns: '10rem 1rem', gap: '0px', marginTop: '0rem',
                        border: '1px solid gainsboro', padding: '15px 5px', position: 'relative'
                    }}>
                        <div><label htmlFor='sito'>Vai al sito ufficiale</label></div>
                        <div><input type='checkbox' id="sito"
                            name='sito'
                            checked={formData2.sito}
                            onChange={handleInputChange} />
                        </div>
                        <div style={{
                            position: 'absolute', left: '11.5rem', top: '15px', fontSize: 'small', cursor: 'pointer',

                        }} ref={btnInfoSitoUff} onClick={vaiAlSitoUff}>
                            → <i style={{ border: '1px solid grey', padding: '0 2px' }}>info</i>
                        </div>

                        <div style={{
                            position: 'absolute', left: '12rem', fontSize: 'small',
                            fontWeight: '600', padding: '7px 1px', display: 'none'
                        }}
                            ref={bannerSitoUff}>
                            <i>L'utente interessato all'acquisto del biglietto sarà indirizzato al sito ufficiale dell'evento</i>
                        </div>

                        <div><label htmlFor="biglietto"> Senza biglietto </label></div>
                        <div><input type="checkbox" id="noBiglietto"
                            name='noBiglietto'
                            checked={formData2.noBiglietto}
                            onChange={handleInputChange} />
                        </div>

                        <div><label htmlFor="biglietto"> Biglietto d'ingresso </label></div>
                        <div><input type="checkbox" id="biglietto"
                            name='biglietto'
                            checked={formData2.biglietto}
                            onChange={handleInputChange} />
                        </div>
                    </div>

                    <div ref={prezzoDom} style={{ display: 'none', marginTop: '2rem', paddingLeft: '1rem' }}>
                        <label htmlFor='prezzo'>Prezzo biglietto </label>
                        <input style={{ width: '5rem', height: '2rem', marginLeft: '3rem' }}
                            type='number' ref={prezzoId} id="prezzo"
                            name='prezzo'
                            defaultValue={formData2.prezzo}
                            placeholder='€'
                            onChange={handleInputChange} />
                        {validate.prezzo && <p style={{ color: 'red' }}><i>{validate.prezzo}</i></p>}

                        <p className='mt-3'>Opzioni biglietto</p>
                        <textarea style={{ padding: '5px', marginTop: '10px' }} className='form-control' id="opzioniBiglietto"
                            name="opzioniBiglietto"
                            rows='5'
                            maxLength={100}
                            onChange={handleInputChange}
                            placeholder='Es: i bambini fino a 3 anni non pagano...'
                            defaultValue={formData2.opzioniBiglietto}
                        >
                        </textarea>
                        {textEmpty.opzioniBiglietto && <p style={{ color: 'red' }}>{textEmpty.opzioniBiglietto}</p>}
                    </div>
                </div>

                <p className='mt-2 fs-6'><i>* campi obbligatori</i></p>

                <div className='mt-3'>
                    <button type='button' className='btn btn-secondary'
                        onClick={() => {
                            const object = { ...formData2, foto: foto }
                            dispatch(aggiorna(object))
                            navigate('/addEvento', { replace: true })
                        }} >
                        Indietro
                    </button>
                    <button type='submit' className='btn btn-primary' style={{ marginLeft: '4rem' }}>Avanti</button>
                </div>
            </form>
        </div>
        <DivBottom />
    </>)
}
export default AddEvento2
